import { scrollToTargetAdjusted } from 'core-framework/util/Dom';
import { search as getLocationSearch } from 'core-framework/window/location';
import { setLocationSearch } from 'store/slice/navigation';
import { SCROLLING_TIMEOUT } from 'core/constant/AnimationTimeout';

const TAB_OFFSET = 60;
export const TAB_HEADER_OFFSET = 60;
export const CARD_EXPAND_TIME_OFFSET = 50;

export const navigateToHashWithOffset = (dispatch: Function, hash: string, setIsScrolling: (isScrolling: boolean) => void, offset: number, isPreventTabsFocus = false) => {
    const queryWithHash = `${getLocationSearch()}${hash}`.replace('?', '');
    dispatch(setLocationSearch({ query: queryWithHash, replaceInHistory: true }));

    scrollToTargetAdjusted(hash, offset);

    if (isPreventTabsFocus) {
        dispatch(setIsScrolling(true));
        setTimeout(() => {
            dispatch(setIsScrolling(false));
        }, SCROLLING_TIMEOUT);
    }
};

export const navigateToHashWithTabBarOffset = (dispatch: Function, hash: string, setIsScrolling: (isScrolling: boolean) => void, isPreventTabsFocus = false) => {
    return navigateToHashWithOffset(dispatch, hash, setIsScrolling, TAB_OFFSET, isPreventTabsFocus);
};
